import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from "react-toastify";


// Action Types
export const CREATE_FORM_FIELD = 'CREATE_FORM_FIELD';
export const GET_FORM_FIELDS = 'GET_FORM_FIELDS';
export const UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
export const DELETE_FORM_FIELD = 'DELETE_FORM_FIELD';

// Actions
const addFormFieldAction = (payload) => ({ type: CREATE_FORM_FIELD, payload: payload });
const getFormFieldsAction = (payload) => ({ type: GET_FORM_FIELDS, payload: payload });
const updateFormFieldAction = (payload) => ({ type: UPDATE_FORM_FIELD, payload: payload });
const deleteFormFieldAction = (payload) => ({ type: DELETE_FORM_FIELD, payload: payload });


// Create Form Field
export const addFormField = (data, params) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${BASEURL}/formFields/createFormField`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(addFormFieldAction(res));
                dispatch(getFormFields(params));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log("Error in adding plan: ", error);
        }
    }
}

// Get Form Fields
export const getFormFields = (params) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.get(`${BASEURL}/formFields/getFormFields`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                // if (res?.data?.success) {
                //     toast.success(res.data.message);
                // }
                dispatch(getFormFieldsAction(res));
            }).catch((error) => {
                // toast.error(error?.response?.data?.message || 'Something went wrong');
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log("Error in getting form fields: ", error);
        }
    }
}

// Update Form Field
export const updateFormField = (data, params) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${BASEURL}/formFields/updateFormField`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(updateFormFieldAction(res));
                dispatch(getFormFields(params));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log("Error in updating form field: ", error);
        }
    }
}

// Delete Form Field
export const deleteFormField = (data, params) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${BASEURL}/formFields/deleteFormField/${data.fieldId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: data
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(deleteFormFieldAction(res));
                dispatch(getFormFields(params));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log("Error in deleting form field: ", error);
        }
    }
}
